var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFireSimple = function SvgIconFireSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.582.787a1 1 0 0 1 .877.277c2.72 2.711 6.406 6.728 6.406 12.061a8.875 8.875 0 1 1-17.75 0c0-2.627 1.318-5.325 2.792-7.547a1 1 0 0 1 1.387-.28l2.79 1.856 2.766-5.812a1 1 0 0 1 .732-.555m.458 2.708-2.647 5.56a1 1 0 0 1-1.457.403L7.039 7.53c-1.134 1.88-1.923 3.837-1.923 5.595a6.875 6.875 0 1 0 13.75 0c0-3.89-2.376-7.056-4.825-9.63",
    clipRule: "evenodd"
  })));
};
export default SvgIconFireSimple;